
























































































import {Component, Vue} from "vue-property-decorator";
import CompaniesDTO, {CompanyDTO} from "../../../dto/CompaniesDTO";
import ProfileService from "../../../services/ProfileService";
import {namespace} from "vuex-class";
import UserDTO from "@/dto/UserDTO";
import CompanyModal from "@/components/profile/CompanyModal.vue";
import RouteNames from "@/router/RouteNames";

const Auth = namespace("Auth");
const Profile = namespace("Profile");
const AppModule = namespace("App");

@Component
export default class Companies extends Vue{

    @Profile.State
    private companies!: CompaniesDTO;

    private message: string | null = null;

    @Auth.Getter
    private hasAdministrativePrivileges!: boolean;

    @Auth.State
    private user!: UserDTO;

    @Profile.Action
    loadCompanies!: (userId: number) => Promise<CompaniesDTO>

    @AppModule.State
    private isMobile!: boolean;

    private TAXATION_PAGE = RouteNames.TAXATION_BUSINESS

    mounted(){
        const userId = this.hasAdministrativePrivileges && this.$route.params.userId ? Number.parseInt(this.$route.params.userId, 10) : this.user.id
        this.message = null;
      this.loadCompanies(userId).then(
          (response) => {
              //OK
          },
          (error) => {
              this.message = error.message;
          }
      )
    }
    showModal(company: CompanyDTO){
        const newCompany = this.cloneCompany(company);
        this.$modal.show(
            CompanyModal,
            {
                company: newCompany,
                onSave: () => {
                    this.mergeCompanies(newCompany, company);
                }
            }
        );
    }

    cloneCompany(company: CompanyDTO) {
        let newCompany = new CompanyDTO();
        newCompany.id = company.id;
        newCompany.name = company.name;
        newCompany.ein = company.ein;
        return newCompany;
    }

    mergeCompanies(source: CompanyDTO, target: CompanyDTO) {
        target.name = source.name;
        target.ein = source.ein;
    }

    addNew(){
        let newCompany = new CompanyDTO();
        this.$modal.show(
            CompanyModal,
            {
                company: newCompany,
                onSave: () => {
                    this.companies.companies.push(newCompany);
                }
            }
        );
    }

    remove(company: CompanyDTO){
        this.companies.companies.forEach((element,index)=>{
            if(element === company) this.companies.companies.splice(index,1);
        });
        this.save();
    }

    save(){
        this.companies.userId = Number.parseInt(this.$route.params.id, 10);
        ProfileService.saveCompanies(this.companies).then(
            (response) => {
                this.companies = response.data;
            },
            (error) => {
                this.message = error.message;
            }
        )
    }

    goToCompany(companyId: number){
        this.$router.push({name: "company", params: {id: this.$route.params.id, companyId: `${companyId}`}})
    }

    goNext(){
        this.$router.push({name: RouteNames.TAXATION_BUSINESS_USER_QUESTIONNAIRES, params: {userId: this.$route.params.userId}})
    }
}
